import { ErrorDisplayTypeEnum } from '@/modules/core/models/enums'
import CustomError from './CustomError'

const DEFAULT_DISPLAY_TYPE = ErrorDisplayTypeEnum.TOAST
const DEFAULT_TITLE = 'copy_error_service_title'
const DEFAULT_MODAL_DESCRIPTION = 'copy_error_service_description'
export default class ServiceError extends CustomError {
  //* Codigo de error del servicio
  code?: string | number | null
  payload?: any

  constructor(error: Partial<ServiceError>) {
    super(error)
    this.name = this.constructor.name
    this.code = error?.code ?? null
    this.displayType = error.displayType ?? DEFAULT_DISPLAY_TYPE
    this.title = error?.title ?? DEFAULT_TITLE
    this.modalDescription = error?.modalDescription ?? DEFAULT_MODAL_DESCRIPTION
    this.payload = error?.payload ?? undefined

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor)
    }
  }
}
